import { setClickAnalyticsData, trackClick, trackPageView } from '@tcp/core/src/analytics/actions';
import { toggleTracker } from '@tcp/core/src/components/common/atoms/BundleTracker/container/BundleTracker.actions';
import {
  getPromotionsData,
  getTrackerState,
} from '@tcp/core/src/components/common/atoms/BundleTracker/container/BundleTracker.selector';
import { openQuickViewWithValues } from '@tcp/core/src/components/common/organisms/QuickViewModal/container/QuickViewModal.actions';
import { setLoginModalMountedState } from '@tcp/core/src/components/features/account/LoginPage/container/LoginPage.actions.js';
import {
  getUserLoggedInState,
  isRememberedUser,
} from '@tcp/core/src/components/features/account/User/container/User.selectors';
import {
  getCategoryBasedProducts,
  getInitialProductsWithFacets,
  getPaginatedProducts,
  getSEOTokenJSON,
  loadCategoryPageSeoData,
  setFromHplp,
  setIsProductLoading,
} from '@tcp/core/src/components/features/browse/CategoryListingPage/container/CategoryListingPage.actions';
import {
  fetchBreadCrumbs,
  getCanonicalUrl,
  getCategoryProductsByPage,
  getIsAlternatePlpEnabled,
  getIsFromHplp,
  getIsHorizontalPlpEnabled,
  getIsPaginatedAlternatePlpEnabled,
  getIsPaginatedPlpLoading,
  getIsShortImage,
  getLongDescription,
  getNavigationData,
  getSeoHeaderCopyText,
  getSeoMetaDesc,
  getSeoTitle,
  getTopPromosContent,
  getTotalProductsCount,
  getSeoHeaderCopyTextLoading,
  getProductLoadingFlag,
  getGenericCarousel,
  getAppliedFilterIdsAndLength,
  getAppliedFilters,
  getFilterMaps,
  getIfCategoryHasCMSPromoCombinations,
  getSeoTokens,
  getIsHidePlpGridAndFilters,
  getSeoPageDirective,
  getTitleDataPerPage,
  getCurrentPageNumber,
} from '@tcp/core/src/components/features/browse/CategoryListingPage/container/CategoryListingPage.selectors';
import {
  addItemsToWishlist,
  getUserFavt,
  setLastDeletedItemIdAction,
} from '@tcp/core/src/components/features/browse/Favorites/container/Favorites.actions';
import {
  wishListFromState,
  getDefaultFavItemInProgressFlag,
} from '@tcp/core/src/components/features/browse/Favorites/container/Favorites.selectors';
import { getBuyItAgainBagPageProducts } from '@tcp/core/src/components/features/CnC/BuyItAgainBagPage/container/BuyItAgainBagPage.actions';
import { fetchPageLayout } from '@tcp/core/src/reduxStore/actions';
import {
  getABTestForStickyFilter,
  getIsBIABagPageCustomVariableEnabled,
  getIsBundleTrackerEnabled,
  getIsOutfitPLPEnabled,
  getIsPLPCategoryPillsEnabled,
  getIsSyteEnabled,
  getNumberOfProductsPerPage,
  getIsOneClickATCEnabled,
  getIsGuestFavEnabled,
  getIsPLPCarouselEnabled,
  getIsFacetedNavigationEnabled,
  getSeoFacetedNavigationConfig,
  getIsCleanUrlForSizeEnabled,
  getCollectionOutfitCatId,
  getNewSEOHreflangLinkEnabled,
  getIsQuickFiltersModuleEnabled,
  getIsHideLeftNavigationOnPLPEnabled,
  getIsSortAndOneHrFilterRedesignEnabled,
} from '@tcp/core/src/reduxStore/selectors/session.selectors';
import { removeSessionStorage } from '@tcp/core/src/utils';

import { addToCartEcom } from '@tcp/core/src/components/features/CnC/AddedToBag/container/AddedToBag.actions';

export const mapStateToProps = (state) => {
  const paginatedProducts = getCategoryProductsByPage(state);
  const plpCatTitles = getTitleDataPerPage(state);
  const recordsPerPage = getNumberOfProductsPerPage(state);
  const totalProductsCount = getTotalProductsCount(state);
  const productsLength = paginatedProducts?.length
    ? (paginatedProducts.length || 0) - (plpCatTitles || 0)
    : 0;
  const totalCount = totalProductsCount <= recordsPerPage ? totalProductsCount : productsLength;

  return {
    recordsPerPage,
    totalProductsCount: getTotalProductsCount(state),
    selectedPageProductCount: totalCount,
    currentPageNumber: getCurrentPageNumber(state),
    paginatedProducts,
    wishListData: wishListFromState(state),
    isShortImage: getIsShortImage(state),
    processedBreadCrumbs: fetchBreadCrumbs(state),
    isABTestForStickyFilter: getABTestForStickyFilter(state),
    isLoggedIn: getUserLoggedInState(state) && !isRememberedUser(state),
    isHorizontalPlpEnabled: getIsHorizontalPlpEnabled(state),
    isProductLoadingFlag: getProductLoadingFlag(state),
    seoTitle: getSeoTitle(state),
    seoMetaDesc: getSeoMetaDesc(state),
    canonicalUrl: getCanonicalUrl(state),
    isPaginatedPlpLoading: getIsPaginatedPlpLoading(state),
    isBundleTrackerEnabled: getIsBundleTrackerEnabled(state),
    isTrackerOpen: getTrackerState(state),
    promotionsData: getPromotionsData(state),
    seoHeaderCopy: getSeoHeaderCopyText(state),
    isSeoHeaderCopyLoaded: getSeoHeaderCopyTextLoading(state),
    topPromosContent: getTopPromosContent(state),
    categoryHasCMSPromoCombinations: getIfCategoryHasCMSPromoCombinations(state),
    isSyteEnabled: getIsSyteEnabled(state),
    navigationData: getNavigationData(state),
    longDescription: getLongDescription(state),
    isOutfitPLPEnabled: getIsOutfitPLPEnabled(state),
    isAlternatePlpEnabled: getIsAlternatePlpEnabled(state),
    isPLPCategoryPillsEnabled: getIsPLPCategoryPillsEnabled(state),
    isPaginatedAlternatePlpEnabled: getIsPaginatedAlternatePlpEnabled(state),
    isBIAABCustomVariableEnabled: getIsBIABagPageCustomVariableEnabled(state),
    isOneClickATCEnabled: getIsOneClickATCEnabled(state),
    isFromHplp: getIsFromHplp(state),
    favAddRemoveLoadingState: getDefaultFavItemInProgressFlag(state),
    isGuestFavEnabled: getIsGuestFavEnabled(state),
    layouts: state.Layouts,
    genericCarouselData: getGenericCarousel(state),
    isPLPCarouselEnabled: getIsPLPCarouselEnabled(state),
    isFacetedNavigationEnabled: getIsFacetedNavigationEnabled(state),
    seoFacetedNavigationConfig: getSeoFacetedNavigationConfig(state),
    appliedFilterIdsAndLength: getAppliedFilterIdsAndLength(state),
    isCleanUrlForSizeEnabled: getIsCleanUrlForSizeEnabled(state),
    filterMaps: getFilterMaps(state),
    collectionOutfitCatID: getCollectionOutfitCatId(state),
    appliedFilters: getAppliedFilters(state),
    isNewSEOHreflangLinkEnabled: getNewSEOHreflangLinkEnabled(state),
    seoTokenList: getSeoTokens(state),
    hidePlpGridAndFilters: getIsHidePlpGridAndFilters(state),
    isQuickFiltersModuleEnabled: getIsQuickFiltersModuleEnabled(state),
    seoPageDirective: getSeoPageDirective(state),
    isHideLeftNavigationOnPLPEnabled: getIsHideLeftNavigationOnPLPEnabled(state),
    isSortAndOneHrFilterRedesignEnabled: getIsSortAndOneHrFilterRedesignEnabled(state),
  };
};

export const mapDispatchToProps = (dispatch) => {
  return {
    getCategoryBasedProductsActn: (payload) => {
      dispatch(getCategoryBasedProducts(payload));
    },
    onQuickViewOpenClick: (payload) => {
      dispatch(openQuickViewWithValues(payload));
    },
    addToBagEcom: (payload) => {
      dispatch(addToCartEcom(payload));
    },
    onAddItemToFavorites: (payload) => {
      dispatch(addItemsToWishlist({ ...payload }));
    },
    onSetLastDeletedItemIdAction: (payload) => {
      dispatch(setLastDeletedItemIdAction(payload));
    },
    loadSeoDetails: (payload) => {
      dispatch(loadCategoryPageSeoData(payload));
    },
    getSEOTokenJSONAction: (payload) => {
      dispatch(getSEOTokenJSON(payload));
    },
    onFavtLoad: (payload) => {
      dispatch(getUserFavt(payload));
    },
    toggleTrackerAction: (payload) => dispatch(toggleTracker(payload)),
    trackClickBundles: (eventData, payload) => {
      dispatch(setClickAnalyticsData(eventData));
      const timer = setTimeout(() => {
        dispatch(trackClick(payload));
        clearTimeout(timer);
      }, 250);
    },
    trackPageLoadSearchRedirect: (payload) => {
      dispatch(setClickAnalyticsData(payload));
      dispatch(
        trackPageView({
          props: {
            initialProps: {
              pageProps: {
                pageData: {
                  ...payload,
                },
              },
            },
          },
        })
      );
      setTimeout(() => {
        dispatch(setClickAnalyticsData({}));
      }, 1000);
      removeSessionStorage('searchRedirect');
    },
    getPaginatedProductsActn: (payload) => {
      dispatch(getPaginatedProducts(payload));
    },
    fetchInitialProductsWithFacets: (payload) => {
      dispatch(getInitialProductsWithFacets(payload));
    },
    trackWishListClick: (payload) => {
      dispatch(setClickAnalyticsData(payload));
      dispatch(trackClick());
    },
    openLoginModalState: (payload) => {
      dispatch(setLoginModalMountedState(payload));
    },
    setFromHplpFlag: (payload) => {
      dispatch(setFromHplp(payload));
    },
    getBIABagPageProducts: () => dispatch(getBuyItAgainBagPageProducts()),
    getHomePageLayout: (apiConfig) => {
      dispatch(fetchPageLayout({ pageName: 'home', apiConfig }));
    },
    setIsProductLoadingActn: (payload) => {
      dispatch(setIsProductLoading(payload));
    },
  };
};
